import React, { useEffect } from "react";
import { usePortalAuthentication } from "../../services/authorizationService";

export const SessionLost = () => {
    const { login } = usePortalAuthentication();

    useEffect(() => {
        login();
    }, []);
    return (<div
        className="loader-container"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-labelledby="session-loast-loader"
    >
        <div className="spinner" aria-hidden="true"></div>
        <div className="loading-text" id="session-lost-loader">Loading...</div>
    </div>);
};